// SV - Curtain width labels: Single/Double panel widths depend on the
// selected Header Type. Liquid renders both candidate suffixes as
// data-* attributes on each [data-curtain-width-label]; this listener
// swaps the visible text when Header Type changes. Scoped by the
// nearest [data-product-variants] ancestor so quickview / multiple
// products on the same page don't bleed into each other.
(function () {
  function updateCurtainWidthLabels(scope) {
    const headerInput = scope.querySelector(
      'input[type="radio"][name^="options[Header Type]"]:checked',
    );
    const headerValue = headerInput ? headerInput.value.toLowerCase() : "";
    const isPleated = headerValue.indexOf("pleat") !== -1;

    scope.querySelectorAll("[data-curtain-width-label]").forEach((el) => {
      const base = el.getAttribute("data-base-value") || "";
      const suffix = isPleated
        ? el.getAttribute("data-width-pleated")
        : el.getAttribute("data-width-flat-top");
      el.textContent = suffix ? base + " " + suffix : base;
    });
  }

  function initCurtainWidthLabels() {
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (
        t &&
        t.tagName === "INPUT" &&
        t.type === "radio" &&
        t.name &&
        t.name.indexOf("options[Header Type]") === 0
      ) {
        const scope = t.closest("[data-product-variants]") || document;
        updateCurtainWidthLabels(scope);
      }
    });

    document.querySelectorAll("[data-product-variants]").forEach((scope) => {
      if (scope.querySelector("[data-curtain-width-label]")) {
        updateCurtainWidthLabels(scope);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCurtainWidthLabels);
  } else {
    initCurtainWidthLabels();
  }
})();

// SV - Clay B2B wholesale price ⇄ URL variant sync.
//
// The Clay wholesale app (clay-wholesale-price.js) decides which variant's
// trade price to render by reading ?variant=<id> from the page URL. When
// that param is absent it falls back to the first available variant — which
// is our cheapest spec — so logged-in trade accounts see the lowest price on
// every product and it never moves as specs change.
//
// Broadcast updates the price block in place on every variant change but only
// writes ?variant= to the URL when its history-state path runs, which it does
// not on these product templates. Result: the URL stays bare and Clay is
// pinned to the lowest variant.
//
// Bridge: on the theme's own `theme:variant:change` event (fired with the
// resolved variant on init and on every change), mirror the variant id into
// ?variant= via replaceState. Clay patches history.replaceState AND listens
// for popstate, so we replaceState and also dispatch a popstate as a
// belt-and-suspenders nudge. Broadcast does not listen for popstate, so this
// cannot feed back into the theme's pipeline.
(function () {
  function syncVariantToUrl(variantId) {
    if (!variantId) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get("variant") === String(variantId)) return;
    url.searchParams.set("variant", variantId);
    const next = url.toString();
    window.history.replaceState({ path: next }, "", next);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }

  document.addEventListener("theme:variant:change", (e) => {
    const variant = e.detail && e.detail.variant;
    syncVariantToUrl(variant && variant.id);
  });
})();

document.addEventListener("alpine:init", () => {
  Alpine.data("CustomLengthOption", (user_length) => ({
    length_options: [],
    selected_length: "",
    min: null,
    max: null,
    user_length: user_length || null,
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.length_options = JSON.parse(
        this.$el.getAttribute("data-length-options"),
      );
      this.selected_length = this.$el.getAttribute("data-selected-length");
      this.min = parseInt(this.$el.getAttribute("data-min"), 10);
      this.max = parseInt(this.$el.getAttribute("data-max"), 10);
      setTimeout(this.SetIOInputLength.bind(this), 1000);
      setTimeout(this.SetIOInputLength.bind(this), 2000);
      this.CheckAddToCart();
    },
    InitWatchers() {
      this.$watch(
        "user_length",
        Alpine.debounce(() => {
          setTimeout(() => {
            // if decimals, round to nearest integer
            if (this.user_length && this.user_length % 1 !== 0) {
              this.user_length = Math.round(this.user_length);
            }
          }, 500);

          // if user length is outside of min-max, disable add to cart
          this.CheckAddToCart();

          // Custom length for curtains
          if (this.$el.querySelectorAll("input[type=radio]").length == 0)
            return;

          let $input;
          if (this.user_length >= 60 && this.user_length <= 90) {
            $input = this.$el.querySelectorAll("input[type=radio]")[0];
          } else if (this.user_length >= 91 && this.user_length <= 100) {
            $input = this.$el.querySelectorAll("input[type=radio]")[1];
          } else if (this.user_length >= 101 && this.user_length <= 110) {
            $input = this.$el.querySelectorAll("input[type=radio]")[2];
          } else if (this.user_length >= 111 && this.user_length <= 120) {
            $input = this.$el.querySelectorAll("input[type=radio]")[3];
          }
          // console.log($input);
          if ($input) {
            $input.checked = true;
            $input.dispatchEvent(new Event("change", { bubbles: true }));
          }

          this.$nextTick(this.SetIOInputLength.bind(this));
        }),
        300,
      );
    },
    CheckAddToCart() {
      let user_length = parseInt(this.user_length, 10);
      let is_valid =
        !!this.user_length &&
        user_length >= this.min &&
        user_length <= this.max;
      let $addToCart = document.querySelector("[data-add-to-cart]");
      if ($addToCart) {
        $addToCart.disabled = !is_valid;
      }
    },
    SetIOInputLength() {
      let $input = document.querySelector(".io--option-length input");
      if (!$input) return;
      $input.value = this.user_length;
      $input.dispatchEvent(new Event("input", { bubbles: true }));
    },
  }));

  Alpine.data("RomanShadeDimensions", () => ({
    // Existing reactive state
    width_whole: null,
    width_fraction: "",
    height_whole: null,
    height_fraction: "",
    // New: Header / Mount written to line item properties
    header_style: "",
    mount_style: "",
    // Open-state flags (one per dropdown)
    width_open: false,
    width_frac_open: false,
    height_open: false,
    height_frac_open: false,
    // Variant matrix
    variants: [],

    // Tier bounds — upper-bound-inclusive convention. Width is `Up to N`
    // for the first tier and `(prev, N]` for subsequent tiers; same for
    // height. Labels MUST match exactly what's used as Shopify variant
    // option values (see chart-*.json widthTiers/heightTiers).
    _WIDTH_TIERS: [
      { maxIn: 24, label: 'Up to 24"' },
      { maxIn: 32, label: '24-32"' },
      { maxIn: 36, label: '32-36"' },
      { maxIn: 42, label: '36-42"' },
      { maxIn: 48, label: '42-48"' },
      { maxIn: 60, label: '48-60"' },
      { maxIn: 72, label: '60-72"' },
      { maxIn: 84, label: '72-84"' },
      { maxIn: 96, label: '84-96"' },
    ],
    _HEIGHT_TIERS: [
      { maxIn: 36, label: 'Up to 36"' },
      { maxIn: 48, label: '36-48"' },
      { maxIn: 54, label: '48-54"' },
      { maxIn: 60, label: '54-60"' },
      { maxIn: 66, label: '60-66"' },
      { maxIn: 72, label: '66-72"' },
      { maxIn: 78, label: '72-78"' },
      { maxIn: 84, label: '78-84"' },
    ],

    init() {
      try {
        this.variants = JSON.parse(
          this.$el.getAttribute("data-variants") || "[]",
        );
      } catch (err) {
        console.error(
          "[RomanShadeDimensions] Failed to parse data-variants JSON. " +
            "Variant selection will be unavailable.",
          err,
        );
        this.variants = [];
      }
      this.CheckAddToCart();
      const trigger = () => {
        this.SelectVariant();
        this.CheckAddToCart();
      };
      this.$watch("width_whole", Alpine.debounce(trigger, 100));
      this.$watch("width_fraction", Alpine.debounce(trigger, 100));
      this.$watch("height_whole", Alpine.debounce(trigger, 100));
      this.$watch("height_fraction", Alpine.debounce(trigger, 100));
      this.$watch("header_style", () => this.CheckAddToCart());
      this.$watch("mount_style", () => this.CheckAddToCart());
      // Prevent constructing a value that exceeds Lantex's dimension limits.
      this.$watch("width_whole", (val) => {
        if (val === 96) this.width_fraction = "";
      });
      // Height tops out at 82" (cordless lift limit), so no fraction may be
      // added to 82 whichever dropdown the shopper touches last.
      this.$watch("height_whole", (val) => {
        if (val === 82) this.height_fraction = "";
      });
      this.$watch("height_fraction", (val) => {
        if (val && this.height_whole === 82) this.height_fraction = "";
      });
    },

    closeAll() {
      this.width_open = false;
      this.width_frac_open = false;
      this.height_open = false;
      this.height_frac_open = false;
    },

    // Closes every dropdown EXCEPT the one named — used by the click
    // handlers on each trigger so opening one always collapses the rest.
    closeOthers(name) {
      const all = ["width", "width_frac", "height", "height_frac"];
      for (const k of all) {
        if (k !== name) this[`${k}_open`] = false;
      }
    },

    get width_combined() {
      if (!this.width_whole) return "";
      return this.width_fraction
        ? `${this.width_whole} ${this.width_fraction}`
        : `${this.width_whole}`;
    },
    get height_combined() {
      if (!this.height_whole) return "";
      return this.height_fraction
        ? `${this.height_whole} ${this.height_fraction}`
        : `${this.height_whole}`;
    },

    _fractionDecimal(s) {
      if (!s) return 0;
      const [num, denom] = s.split("/").map(Number);
      if (!Number.isFinite(num) || !Number.isFinite(denom) || denom === 0)
        return 0;
      return num / denom;
    },
    get widthDecimal() {
      if (!this.width_whole) return null;
      return (
        Number(this.width_whole) + this._fractionDecimal(this.width_fraction)
      );
    },
    get heightDecimal() {
      if (!this.height_whole) return null;
      return (
        Number(this.height_whole) + this._fractionDecimal(this.height_fraction)
      );
    },

    _tierLabel(tiers, decimal) {
      if (decimal == null) return null;
      for (const t of tiers) {
        if (decimal <= t.maxIn) return t.label;
      }
      return null; // decimal exceeds the largest tier
    },
    widthTierLabel(decimal) {
      return this._tierLabel(this._WIDTH_TIERS, decimal);
    },
    heightTierLabel(decimal) {
      return this._tierLabel(this._HEIGHT_TIERS, decimal);
    },

    MatchingVariant() {
      const w = this.widthTierLabel(this.widthDecimal);
      const h = this.heightTierLabel(this.heightDecimal);
      if (!w || !h) return null;
      return (
        this.variants.find(
          (v) => v.options && v.options.Width === w && v.options.Height === h,
        ) || null
      );
    },

    SelectVariant() {
      const variant = this.MatchingVariant();
      if (!variant) return;

      // Click the auto-rendered radios for Width and Height matching this
      // variant's option values. Theme.js listens for changes on
      // [data-single-option-selector] radios and runs its variant-change
      // pipeline (recomputes form variant_id, updates price block,
      // refreshes SelloutVariants availability). The radios are kept in
      // the DOM but visually hidden via CSS on this template.
      for (const optName of ["Width", "Height"]) {
        const optValue = variant.options[optName];
        if (!optValue) continue;
        // Auto-rendered radio name pattern: `options[Width]-{uniq_id}` etc.
        // Match by name-prefix + value.
        const $radio = document.querySelector(
          `input[type="radio"][data-single-option-selector][name^="options[${optName}]"][value="${CSS.escape(optValue)}"]`,
        );
        if ($radio && !$radio.checked) {
          $radio.checked = true;
          $radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    },

    CheckAddToCart() {
      const $addToCart = document.querySelector("[data-add-to-cart]");
      if (!$addToCart) return;
      const ok =
        !!this.width_whole &&
        !!this.height_whole &&
        !!this.header_style &&
        !!this.mount_style;
      $addToCart.disabled = !ok;
    },
  }));

  Alpine.data("RodLength", () => ({
    rod_length: null,
    length_open: false,
    variants: [],
    _self_dispatching: false,

    init() {
      this.variants = JSON.parse(
        this.$el.getAttribute("data-variants") || "[]",
      );
      this.CheckAddToCart();
      this.$watch("rod_length", () => {
        this.SelectVariant();
        this.CheckAddToCart();
      });

      // Re-resolve when Shopify's standard variant pickers (Rod Type, Color)
      // change the form variant_id. Guarded against feedback loops triggered
      // by our own dispatches in SelectVariant.
      const $idInput = this.GetIdInput();
      if ($idInput) {
        $idInput.addEventListener("change", () => {
          if (this._self_dispatching) return;
          if (this.rod_length) this.SelectVariant();
        });
      }
    },

    GetIdInput() {
      const formId = this.$el.getAttribute("data-form-id");
      const $form = formId ? document.getElementById(formId) : null;
      return $form
        ? $form.querySelector("select[name='id'], input[name='id']")
        : document.querySelector("select[name='id'], input[name='id']");
    },

    get is_valid() {
      return (
        !!this.rod_length && this.rod_length >= 36 && this.rod_length <= 120
      );
    },

    // Variants matching the currently-selected non-Length option values
    // (e.g. Rod Type + Color). Falls back to all variants when option
    // metadata is absent (legacy single-axis products).
    get current_filtered_variants() {
      const $idInput = this.GetIdInput();
      const currentId =
        $idInput && $idInput.value ? Number($idInput.value) : null;
      const current = this.variants.find((v) => v.id === currentId);
      if (!current || !current.options) return this.variants;
      return this.variants.filter((v) => {
        if (!v.options) return false;
        for (const name of Object.keys(current.options)) {
          if (name.toLowerCase() === "length") continue;
          if (v.options[name] !== current.options[name]) return false;
        }
        return true;
      });
    },

    get price_display() {
      const variant = this.MatchingVariant();
      if (!variant) return "";
      return "$" + (variant.price / 100).toFixed(0);
    },

    LengthTierIndex(length) {
      if (!length) return -1;
      if (length >= 36 && length <= 48) return 0;
      if (length >= 49 && length <= 60) return 1;
      if (length >= 61 && length <= 72) return 2;
      if (length >= 73 && length <= 84) return 3;
      if (length >= 85 && length <= 96) return 4;
      if (length >= 97 && length <= 108) return 5;
      if (length >= 109 && length <= 120) return 6;
      return -1;
    },

    MatchingVariant() {
      const filtered = this.current_filtered_variants;
      const idx = this.LengthTierIndex(this.rod_length);
      if (idx === -1) return null;
      return filtered[idx] || null;
    },

    SelectVariant() {
      const variant = this.MatchingVariant();
      if (!variant) return;

      this._self_dispatching = true;
      try {
        // Preferred path: click the (hidden) Length option radio so Shopify's
        // standard variant pipeline runs — it'll recompute the form variant_id,
        // update the price, refresh SelloutVariants availability, etc. This
        // keeps SelloutVariants matching consistent across all axes.
        if (variant.options) {
          const lengthValue =
            variant.options.Length !== undefined
              ? variant.options.Length
              : variant.options.length;
          if (lengthValue !== undefined && lengthValue !== null) {
            const $lengthRadios = document.querySelectorAll(
              'input[type="radio"][name^="options[Length]"]',
            );
            let clicked = false;
            $lengthRadios.forEach((r) => {
              if (r.value === lengthValue) {
                if (!r.checked) {
                  r.checked = true;
                  r.dispatchEvent(new Event("change", { bubbles: true }));
                }
                clicked = true;
              }
            });
            if (clicked) return;
          }
        }

        // Fallback: direct form id manipulation (single-axis product or
        // option metadata absent). Legacy behavior preserved.
        const $idInput = this.GetIdInput();
        if (!$idInput) return;
        const $variantRadio = document.querySelector(
          `input[type="radio"][value="${variant.id}"]`,
        );
        if ($variantRadio) {
          $variantRadio.checked = true;
          $variantRadio.dispatchEvent(new Event("change", { bubbles: true }));
          return;
        }
        $idInput.value = String(variant.id);
        $idInput.dispatchEvent(new Event("change", { bubbles: true }));
      } finally {
        this._self_dispatching = false;
      }
    },

    CheckAddToCart() {
      const $addToCart = document.querySelector("[data-add-to-cart]");
      if ($addToCart) $addToCart.disabled = !this.is_valid;
    },
  }));

  Alpine.data("BlackoutToggle", () => ({
    blackout_added: false,
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      this.$watch("blackout_added", () => {
        let $checkbox = document.querySelector(
          ".io--option-blackout input[type=checkbox]",
        );
        if (!$checkbox) return;
        $checkbox.checked = this.blackout_added;
        $checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      });
    },
  }));
});
